import guide from './markets_customer_help.json';

export const MARKETS_HELP_VERSION = guide.content_version;
export const MARKETS_HELP_CONTENT = Object.fromEntries(['page_title','quick_guide','key_metrics','tip'].map(key=>[key,guide[key]]));
export const MARKETS_HELP_TIPS = guide.tips_and_tricks;
